import { all, takeLatest } from 'redux-saga/effects';
import { actions as actionsUi } from 'ducks/ui';
import onboarding from './onboarding';
import setConfSaga from './setConf';

export default function* rootSaga() {
  yield all([...onboarding]);
  yield all([takeLatest([actionsUi.setConf], setConfSaga)]);
}
